export const S3_IMAGES_URL = 'https://static.solartrip.com/images/achievement/';
export const S3_MP4_URL = 'https://static.solartrip.com/mp4/achievement/';

export const FAQ_DATA = [
  {
    id: 1,
    title: 'What is a collectible Planet reward?',
    content:
      'It’s a digital collectible prize, or an NFT, that a Solartrip customer is receives after completing a respective action. After the Planet reward has been generated, its owner can add it to his planetary system in their profile or put it in a digital wallet.',
  },
  {
    id: 2,
    title: 'What is an NFT?',
    content:
      'A non-fungible token, or NFT, is a digital asset representing ownership of unique items or access to something, whether digital or physical. Most commonly, NFTs are used for digital collectibles. Ownership and transfer of an NFT are secured by the Ethereum blockchain ensuring that one NFT has only one owner at any given time and that nobody can modify the history of the token’s ownership.',
  },
  {
    id: 3,
    title: 'When can I add my Planet reward to my planetary system?',
    content:
      'You will be able to add your Planet reward to your planetary collection after your activity on Solartrip has been concluded.',
  },
  {
    id: 4,
    title:
      'Will I get a Planet if I have bought a ticket or booked a hotel but missed my trip for some reason?',
    content:
      'The Planet reward will be generated only after a respective action has been completed. You will receive your Planets rewards only after taking a flight or staying at the hotel.',
  },
  {
    id: 5,
    title: 'What is cryptocurrency?',
    content:
      'Cryptocurrency is a digital currency or store of value that uses blockchain, a digital transaction ledger, to record and secure online transactions. Cryptocurrencies can be used to buy goods and services. Currently, the most traded cryptocurrency is Bitcoin, followed by Ethereum.',
  },
  {
    id: 6,
    title: 'How to pay for your trip with crypto?',
    content:
      'Choose your flight or hotel. Select the crypto payment method. Stay anonymous and independent, if necessary. Pay for your trip. If your payment method is a cryptocurrency, you can make a purchase via the <a href="http://crypto.com/" target="_blank" rel="noopener noreferrer">crypto.com</a> app, Metamask wallet, or other wallets through <a href="http://walletconnect.com/" target="_blank" rel="noopener norefferer">walletconnect.com</a>. It’s fast and secure.',
  },
  {
    id: 7,
    title: 'What is a digital wallet?',
    content:
      'A blockchain wallet is a digital storage that enables you to store and make transactions with cryptocurrency. In its simplest form, a wallet comprises a public and a private key, which are cryptographically generated.',
  },
  {
    id: 8,
    title: 'Which digital wallet can I use to store my collectible Planet?',
    content:
      'There are many digital wallets, such as Phantom, which equip you with a wallet address, key vault, secure login, and backup options to manage your digital assets securely. Several browsers and mobile app-based wallets support Solana. Find the right one for you and learn more about it on the <a href="https://solana.com/ecosystem/explore?categories=wallet" target="_blank" rel="noopener noreferrer">Solana Ecosystem</a> page.',
  },
];
